document.addEventListener('DOMContentLoaded', function() {
    
  
    function initSwiper() {
  
      document.querySelectorAll('.social-feed--contents').forEach((area, index) => {
        const container = area.querySelector('.social-feed--swiper');
        let swipers = [];
  
        if (!container.swiper) {
            const pagination = area.querySelector('.social-feed-pagination');
  
            swipers[index] = new Swiper(container, {
              slidesPerView: 1.2,
              spaceBetween: 20,
              pagination: {
                el: pagination,
                clickable: true,
                type: "progressbar"
              },
              breakpoints: {
                480: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 3.2,
                    spaceBetween: 20,
                },
                1440: {
                    slidesPerView: 4.2,
                    spaceBetween: 20,
                },
                1920: {
                    slidesPerView: 3.2,
                    spaceBetween: 20,
                }
              }
            });
        }
      });
    }

    initSwiper();
});
  